const faqItems = [
  {
    q: '91电影真的完全免费吗？',
    a: '是的，91电影所有影片资源均免费提供，无需注册、无需付费、无需订阅。我们致力于为广大影迷提供零门槛的免费在线观看体验，让每个人都能轻松享受高清影视内容。',
  },
  {
    q: '需要下载软件或APP才能观看吗？',
    a: '不需要。91电影是纯网页端平台，使用浏览器打开即可直接观看。电脑、手机、平板全终端自适应，无需下载任何APP或安装任何插件，即开即看，方便快捷。',
  },
  {
    q: '影片画质怎么样？播放会卡顿吗？',
    a: '平台提供1080P高清画质，部分影片支持4K播放。我们采用先进的CDN加速和视频压缩技术，确保播放流畅不卡顿。建议在网络环境良好的情况下观看以获得最佳体验。',
  },
  {
    q: '片库多久更新一次？有哪些类型的影片？',
    a: '91电影片库保持每日更新，平均每天新增50部以上影片。涵盖动作、喜剧、悬疑、科幻、爱情、剧情、纪录片、动画等全类型国产电影免费大片，满足不同观众的观影需求。',
  },
  {
    q: '在国外可以访问91电影吗？',
    a: '91电影目前主要面向国内用户提供服务。部分海外地区可能因网络限制无法正常访问或播放。如遇访问问题，建议使用国内网络环境进行观看，以获得流畅的免费在线观看体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">关于91电影的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base font-heading text-foreground-950 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}